import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { endpoints } from '../../environments/endpoint';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationEmailService {

  constructor(private http: HttpClient) { }

  public validateEmail(email: string): Observable<boolean>{
    
    return this.http.get<boolean>(endpoints.REST_GTECLOUD_GET_USER_VALIDATE_EMAIL
      .replace('{emailUser}', email));
  }
}
